import React from 'react';
import { Handshake, SlidersHorizontal, Headphones, CalendarCheck } from 'lucide-react';
const steps = [{
  num: '1',
  title: 'Connect',
  desc: 'We learn your business and what matters most.',
  icon: Handshake
}, {
  num: '2',
  title: 'Customize',
  desc: 'We design a PEO solution built around your team.',
  icon: SlidersHorizontal
}, {
  num: '3',
  title: 'Support',
  desc: 'Real people. Real HR guidance. When you need it.',
  icon: Headphones
}, {
  num: '4',
  title: 'Follow Through',
  desc: 'Regular check-ins to support your team and plan ahead.',
  icon: CalendarCheck
}];
export function StepsSection() {
  return <section className="py-16 bg-white" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="text-center mb-16" data-id="element-108">
          <h2 className="text-3xl md:text-4xl font-bold text-navy" data-id="element-109">
            Getting Started Is Simple
          </h2>
        </div>

        <div className="relative" data-id="element-110">
          {steps.map((step, index) => <div key={index} className="flex gap-8 relative group" data-id="element-111">
              {/* Timeline column */}
              <div className="flex flex-col items-center flex-shrink-0" data-id="element-112">
                {/* Glowing icon circle */}
                <div className="relative" data-id="element-113">
                  {/* Outer glow ring - animated */}
                  <div className="absolute -inset-2 bg-gradient-to-br rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-md" style={{
                background: index % 2 === 0 ? 'radial-gradient(circle, rgba(232,114,42,0.3), transparent)' : 'radial-gradient(circle, rgba(27,42,74,0.3), transparent)'
              }} data-id="element-114"></div>
                  {/* Pulse ring */}
                  <div className="absolute -inset-1 rounded-2xl animate-pulse opacity-30" style={{
                background: index % 2 === 0 ? 'linear-gradient(135deg, rgba(232,114,42,0.4), rgba(232,114,42,0.1))' : 'linear-gradient(135deg, rgba(27,42,74,0.4), rgba(27,42,74,0.1))',
                animationDelay: `${index * 0.5}s`,
                animationDuration: '3s'
              }} data-id="element-115"></div>
                  {/* Icon */}
                  <div className={`relative w-16 h-16 rounded-2xl flex items-center justify-center text-white shadow-lg z-10 transition-transform duration-300 group-hover:scale-110 ${index % 2 === 0 ? 'bg-orange' : 'bg-navy'}`} data-id="element-116">
                    <step.icon className="w-7 h-7" data-id="element-117" />
                  </div>
                </div>

                {/* Connecting line */}
                {index < steps.length - 1 && <div className="relative w-0.5 flex-grow my-3 min-h-[60px]" data-id="element-118">
                    <div className="absolute inset-0 bg-gradient-to-b from-gray-300 via-gray-200 to-gray-300 rounded-full" data-id="element-119"></div>
                    {/* Animated beam traveling down the line */}
                    <div className="absolute inset-x-0 h-8 rounded-full animate-pulse" style={{
                background: 'linear-gradient(to bottom, transparent, rgba(232,114,42,0.6), transparent)',
                animationDelay: `${index * 0.8}s`,
                animationDuration: '2.5s'
              }} data-id="element-120"></div>
                  </div>}
              </div>

              {/* Content card */}
              <div className={`pb-8 ${index === steps.length - 1 ? 'pb-0' : ''} flex-grow`} data-id="element-121">
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 group-hover:shadow-md group-hover:border-gray-200 transition-all duration-300 relative overflow-hidden" data-id="element-122">
                  {/* Subtle gradient background on hover */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{
                background: index % 2 === 0 ? 'linear-gradient(135deg, rgba(232,114,42,0.03), transparent)' : 'linear-gradient(135deg, rgba(27,42,74,0.03), transparent)'
              }} data-id="element-123"></div>
                  <div className="relative z-10" data-id="element-124">
                    <span className={`text-xs font-bold uppercase tracking-widest ${index % 2 === 0 ? 'text-orange' : 'text-navy-light'}`} data-id="element-125">
                      Step {step.num}
                    </span>
                    <h3 className="text-2xl font-bold text-navy mt-1 mb-2" data-id="element-126">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-lg leading-relaxed" data-id="element-127">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}